module.exports = __webpack_public_path__ + "static/media/trolley.7783c6ef.png";